export const API_BASE_URL = window._env_?.REACT_APP_DOMAIN_NAME || process.env.REACT_APP_DOMAIN_NAME;
